import React from 'react'

const CustomCheckboxLabel = ({ id, checked, onChange, children }) => {
	return (
		<label htmlFor={id} className='flex items-start gap-2 mt-2 cursor-pointer select-none'>
			<input
				type='checkbox'
				checked={checked}
				onChange={onChange}
				className='hidden'
				id={id}
			/>
			<span
				className={`
					w-5 h-5 min-w-[1.25rem] min-h-[1.25rem] flex items-center justify-center border-2 rounded
					${checked ? 'bg-accent border-accent' : 'border-gray-400'}
				`}>
				{checked && (
					<svg
						className='w-[18px] h-[18px] text-white'
						fill='none'
						stroke='currentColor'
						strokeWidth={3}
						viewBox='0 0 24 24'>
						<path strokeLinecap='round' strokeLinejoin='round' d='M5 13l4 4L19 7' />
					</svg>
				)}
			</span>
			<span className='text-[14px] leading-[14px]'>{children}</span>
		</label>
	)
}

export default CustomCheckboxLabel
